"use strict";

var _possibleConstructorReturn = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/builds/addsome-io/addsome-monorepo/common/temp/node_modules/.registry.npmjs.org/@babel/runtime/7.5.5/node_modules/@babel/runtime/helpers/classCallCheck");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var class_validator_1 = require("class-validator");

var class_transformer_1 = require("class-transformer");

var ComputerVisionTypes;

(function (ComputerVisionTypes) {
  ComputerVisionTypes["ObjectDetection"] = "ObjectDetection";
  ComputerVisionTypes["VisualSearch"] = "VisualSearch";
  ComputerVisionTypes["PerspectiveMesh"] = "PerspectiveMesh";
  ComputerVisionTypes["InPainting"] = "InPainting";
  ComputerVisionTypes["Segmentation"] = "Segmentation";
  ComputerVisionTypes["TextureMatching"] = "TextureMatching";
})(ComputerVisionTypes = exports.ComputerVisionTypes || (exports.ComputerVisionTypes = {}));

var CompVisionStatuses;

(function (CompVisionStatuses) {
  CompVisionStatuses["Processing"] = "Processing";
  CompVisionStatuses["Completed"] = "Completed";
  CompVisionStatuses["Failed"] = "Failed";
})(CompVisionStatuses = exports.CompVisionStatuses || (exports.CompVisionStatuses = {}));

var CompVisionRegionDTO = function CompVisionRegionDTO() {
  _classCallCheck(this, CompVisionRegionDTO);
};

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], CompVisionRegionDTO.prototype, "x", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], CompVisionRegionDTO.prototype, "y", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], CompVisionRegionDTO.prototype, "width", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], CompVisionRegionDTO.prototype, "height", void 0);

exports.CompVisionRegionDTO = CompVisionRegionDTO;

var SimilarityDTO = function SimilarityDTO() {
  _classCallCheck(this, SimilarityDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], SimilarityDTO.prototype, "mediaId", void 0);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], SimilarityDTO.prototype, "productId", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], SimilarityDTO.prototype, "score", void 0);

exports.SimilarityDTO = SimilarityDTO;

var SurfaceDTO = function SurfaceDTO() {
  _classCallCheck(this, SurfaceDTO);
};

__decorate([class_validator_1.IsNumber({}, {
  each: true
}), __metadata("design:type", Array)], SurfaceDTO.prototype, "withPoints", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], SurfaceDTO.prototype, "type", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], SurfaceDTO.prototype, "side", void 0);

exports.SurfaceDTO = SurfaceDTO;

var LineDTO = function LineDTO() {
  _classCallCheck(this, LineDTO);
};

__decorate([class_validator_1.IsNumber({}, {
  each: true
}), __metadata("design:type", Array)], LineDTO.prototype, "points", void 0);

exports.LineDTO = LineDTO;

var PointDTO = function PointDTO() {
  _classCallCheck(this, PointDTO);
};

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], PointDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], PointDTO.prototype, "y", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], PointDTO.prototype, "z", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], PointDTO.prototype, "x", void 0);

exports.PointDTO = PointDTO;

var CompVisionObjectDTO = function CompVisionObjectDTO() {
  _classCallCheck(this, CompVisionObjectDTO);
};

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return CompVisionRegionDTO;
}), __metadata("design:type", CompVisionRegionDTO)], CompVisionObjectDTO.prototype, "region", void 0);

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], CompVisionObjectDTO.prototype, "maskId", void 0);

__decorate([class_validator_1.IsString(), __metadata("design:type", String)], CompVisionObjectDTO.prototype, "class", void 0);

exports.CompVisionObjectDTO = CompVisionObjectDTO;

var CompVisionRequestCreationDTO = function CompVisionRequestCreationDTO() {
  _classCallCheck(this, CompVisionRequestCreationDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], CompVisionRequestCreationDTO.prototype, "computerVisionFileId", void 0);

exports.CompVisionRequestCreationDTO = CompVisionRequestCreationDTO;

var CompVisionRequestUpdateDTO = function CompVisionRequestUpdateDTO() {
  _classCallCheck(this, CompVisionRequestUpdateDTO);
};

__decorate([class_validator_1.IsEnum(CompVisionStatuses), class_validator_1.IsOptional(), __metadata("design:type", String)], CompVisionRequestUpdateDTO.prototype, "status", void 0);

__decorate([class_validator_1.Allow(), __metadata("design:type", Object)], CompVisionRequestUpdateDTO.prototype, "processingResult", void 0);

exports.CompVisionRequestUpdateDTO = CompVisionRequestUpdateDTO;

var ComputerVisionDTO = function ComputerVisionDTO() {
  _classCallCheck(this, ComputerVisionDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ComputerVisionDTO.prototype, "id", void 0);

__decorate([class_validator_1.IsEnum(CompVisionStatuses), __metadata("design:type", String)], ComputerVisionDTO.prototype, "status", void 0);

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], ComputerVisionDTO.prototype, "computerVisionFileId", void 0);

__decorate([class_validator_1.IsDate(), __metadata("design:type", Date)], ComputerVisionDTO.prototype, "createDate", void 0);

exports.ComputerVisionDTO = ComputerVisionDTO;

var ObjectDetectionResultDTO = function ObjectDetectionResultDTO() {
  _classCallCheck(this, ObjectDetectionResultDTO);
};

__decorate([class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return CompVisionObjectDTO;
}), __metadata("design:type", Array)], ObjectDetectionResultDTO.prototype, "objects", void 0);

__decorate([class_validator_1.IsString(), class_validator_1.IsOptional(), __metadata("design:type", String)], ObjectDetectionResultDTO.prototype, "masksFileId", void 0);

__decorate([class_validator_1.IsArray(), class_validator_1.IsOptional(), __metadata("design:type", Array)], ObjectDetectionResultDTO.prototype, "masks", void 0);

exports.ObjectDetectionResultDTO = ObjectDetectionResultDTO;

var ObjectDetectionUpdateDTO =
/*#__PURE__*/
function (_CompVisionRequestUpd) {
  _inherits(ObjectDetectionUpdateDTO, _CompVisionRequestUpd);

  function ObjectDetectionUpdateDTO() {
    _classCallCheck(this, ObjectDetectionUpdateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ObjectDetectionUpdateDTO).apply(this, arguments));
  }

  return ObjectDetectionUpdateDTO;
}(CompVisionRequestUpdateDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return ObjectDetectionResultDTO;
}), __metadata("design:type", ObjectDetectionResultDTO)], ObjectDetectionUpdateDTO.prototype, "processingResult", void 0);

exports.ObjectDetectionUpdateDTO = ObjectDetectionUpdateDTO;

var ObjectDetectionDTO =
/*#__PURE__*/
function (_ComputerVisionDTO) {
  _inherits(ObjectDetectionDTO, _ComputerVisionDTO);

  function ObjectDetectionDTO() {
    _classCallCheck(this, ObjectDetectionDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(ObjectDetectionDTO).apply(this, arguments));
  }

  return ObjectDetectionDTO;
}(ComputerVisionDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return ObjectDetectionResultDTO;
}), class_validator_1.IsOptional(), __metadata("design:type", ObjectDetectionResultDTO)], ObjectDetectionDTO.prototype, "processingResult", void 0);

exports.ObjectDetectionDTO = ObjectDetectionDTO;

var VisualSearchCreationDTO = function VisualSearchCreationDTO() {
  _classCallCheck(this, VisualSearchCreationDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], VisualSearchCreationDTO.prototype, "computerVisionFileId", void 0);

__decorate([class_validator_1.IsDefined(), class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return CompVisionRegionDTO;
}), __metadata("design:type", CompVisionRegionDTO)], VisualSearchCreationDTO.prototype, "region", void 0);

exports.VisualSearchCreationDTO = VisualSearchCreationDTO;

var VisualSearchResultDTO = function VisualSearchResultDTO() {
  _classCallCheck(this, VisualSearchResultDTO);
};

__decorate([class_validator_1.IsDefined(), class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return SimilarityDTO;
}), __metadata("design:type", Array)], VisualSearchResultDTO.prototype, "similarities", void 0);

exports.VisualSearchResultDTO = VisualSearchResultDTO;

var VisualSearchUpdateDTO =
/*#__PURE__*/
function (_CompVisionRequestUpd2) {
  _inherits(VisualSearchUpdateDTO, _CompVisionRequestUpd2);

  function VisualSearchUpdateDTO() {
    _classCallCheck(this, VisualSearchUpdateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(VisualSearchUpdateDTO).apply(this, arguments));
  }

  return VisualSearchUpdateDTO;
}(CompVisionRequestUpdateDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return VisualSearchResultDTO;
}), __metadata("design:type", VisualSearchResultDTO)], VisualSearchUpdateDTO.prototype, "processingResult", void 0);

exports.VisualSearchUpdateDTO = VisualSearchUpdateDTO;

var VisualSearchDTO =
/*#__PURE__*/
function (_ComputerVisionDTO2) {
  _inherits(VisualSearchDTO, _ComputerVisionDTO2);

  function VisualSearchDTO() {
    _classCallCheck(this, VisualSearchDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(VisualSearchDTO).apply(this, arguments));
  }

  return VisualSearchDTO;
}(ComputerVisionDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return VisualSearchResultDTO;
}), __metadata("design:type", VisualSearchResultDTO)], VisualSearchDTO.prototype, "processingResult", void 0);

exports.VisualSearchDTO = VisualSearchDTO;

var VisualSearchQueryDTO = function VisualSearchQueryDTO() {
  _classCallCheck(this, VisualSearchQueryDTO);
};

__decorate([class_validator_1.IsOptional(), class_validator_1.IsBooleanString(), __metadata("design:type", String)], VisualSearchQueryDTO.prototype, "result", void 0);

exports.VisualSearchQueryDTO = VisualSearchQueryDTO;

var PerspectiveMeshResultDTO = function PerspectiveMeshResultDTO() {
  _classCallCheck(this, PerspectiveMeshResultDTO);
};

__decorate([class_validator_1.IsNumber(), __metadata("design:type", Number)], PerspectiveMeshResultDTO.prototype, "layoutType", void 0);

__decorate([class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return SurfaceDTO;
}), __metadata("design:type", Array)], PerspectiveMeshResultDTO.prototype, "surfaces", void 0);

__decorate([class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return LineDTO;
}), __metadata("design:type", Array)], PerspectiveMeshResultDTO.prototype, "lines", void 0);

__decorate([class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return PointDTO;
}), __metadata("design:type", Array)], PerspectiveMeshResultDTO.prototype, "points", void 0);

__decorate([class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return LineDTO;
}), __metadata("design:type", Array)], PerspectiveMeshResultDTO.prototype, "verticalLines", void 0);

exports.PerspectiveMeshResultDTO = PerspectiveMeshResultDTO;

var PerspectiveMeshUpdateDTO =
/*#__PURE__*/
function (_CompVisionRequestUpd3) {
  _inherits(PerspectiveMeshUpdateDTO, _CompVisionRequestUpd3);

  function PerspectiveMeshUpdateDTO() {
    _classCallCheck(this, PerspectiveMeshUpdateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(PerspectiveMeshUpdateDTO).apply(this, arguments));
  }

  return PerspectiveMeshUpdateDTO;
}(CompVisionRequestUpdateDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return PerspectiveMeshResultDTO;
}), __metadata("design:type", PerspectiveMeshResultDTO)], PerspectiveMeshUpdateDTO.prototype, "processingResult", void 0);

exports.PerspectiveMeshUpdateDTO = PerspectiveMeshUpdateDTO;

var PerspectiveMeshDTO =
/*#__PURE__*/
function (_ComputerVisionDTO3) {
  _inherits(PerspectiveMeshDTO, _ComputerVisionDTO3);

  function PerspectiveMeshDTO() {
    _classCallCheck(this, PerspectiveMeshDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(PerspectiveMeshDTO).apply(this, arguments));
  }

  return PerspectiveMeshDTO;
}(ComputerVisionDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return PerspectiveMeshResultDTO;
}), __metadata("design:type", PerspectiveMeshResultDTO)], PerspectiveMeshDTO.prototype, "processingResult", void 0);

exports.PerspectiveMeshDTO = PerspectiveMeshDTO;

var InPaintingCreationDTO =
/*#__PURE__*/
function (_CompVisionRequestCre) {
  _inherits(InPaintingCreationDTO, _CompVisionRequestCre);

  function InPaintingCreationDTO() {
    _classCallCheck(this, InPaintingCreationDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(InPaintingCreationDTO).apply(this, arguments));
  }

  return InPaintingCreationDTO;
}(CompVisionRequestCreationDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return PerspectiveMeshResultDTO;
}), __metadata("design:type", PerspectiveMeshResultDTO)], InPaintingCreationDTO.prototype, "perspectiveMesh", void 0);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return CompVisionRegionDTO;
}), __metadata("design:type", CompVisionRegionDTO)], InPaintingCreationDTO.prototype, "region", void 0);

exports.InPaintingCreationDTO = InPaintingCreationDTO;

var InPaintingResultDTO = function InPaintingResultDTO() {
  _classCallCheck(this, InPaintingResultDTO);
};

exports.InPaintingResultDTO = InPaintingResultDTO;

var InPaintingUpdateDTO =
/*#__PURE__*/
function (_CompVisionRequestUpd4) {
  _inherits(InPaintingUpdateDTO, _CompVisionRequestUpd4);

  function InPaintingUpdateDTO() {
    _classCallCheck(this, InPaintingUpdateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(InPaintingUpdateDTO).apply(this, arguments));
  }

  return InPaintingUpdateDTO;
}(CompVisionRequestUpdateDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return InPaintingResultDTO;
}), __metadata("design:type", InPaintingResultDTO)], InPaintingUpdateDTO.prototype, "processingResult", void 0);

exports.InPaintingUpdateDTO = InPaintingUpdateDTO;

var InPaintingDTO =
/*#__PURE__*/
function (_ComputerVisionDTO4) {
  _inherits(InPaintingDTO, _ComputerVisionDTO4);

  function InPaintingDTO() {
    _classCallCheck(this, InPaintingDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(InPaintingDTO).apply(this, arguments));
  }

  return InPaintingDTO;
}(ComputerVisionDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return InPaintingResultDTO;
}), __metadata("design:type", InPaintingResultDTO)], InPaintingDTO.prototype, "processingResult", void 0);

exports.InPaintingDTO = InPaintingDTO;

var TextureMatchingResultDTO = function TextureMatchingResultDTO() {
  _classCallCheck(this, TextureMatchingResultDTO);
};

__decorate([class_validator_1.ValidateNested({
  each: true
}), class_transformer_1.Type(function () {
  return SimilarityDTO;
}), __metadata("design:type", Array)], TextureMatchingResultDTO.prototype, "similarities", void 0);

exports.TextureMatchingResultDTO = TextureMatchingResultDTO;

var TextureMatchingUpdateDTO =
/*#__PURE__*/
function (_CompVisionRequestUpd5) {
  _inherits(TextureMatchingUpdateDTO, _CompVisionRequestUpd5);

  function TextureMatchingUpdateDTO() {
    _classCallCheck(this, TextureMatchingUpdateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextureMatchingUpdateDTO).apply(this, arguments));
  }

  return TextureMatchingUpdateDTO;
}(CompVisionRequestUpdateDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return TextureMatchingResultDTO;
}), __metadata("design:type", TextureMatchingResultDTO)], TextureMatchingUpdateDTO.prototype, "processingResult", void 0);

exports.TextureMatchingUpdateDTO = TextureMatchingUpdateDTO;

var TextureMatchingDTO =
/*#__PURE__*/
function (_ComputerVisionDTO5) {
  _inherits(TextureMatchingDTO, _ComputerVisionDTO5);

  function TextureMatchingDTO() {
    _classCallCheck(this, TextureMatchingDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextureMatchingDTO).apply(this, arguments));
  }

  return TextureMatchingDTO;
}(ComputerVisionDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return TextureMatchingResultDTO;
}), __metadata("design:type", TextureMatchingResultDTO)], TextureMatchingDTO.prototype, "processingResult", void 0);

exports.TextureMatchingDTO = TextureMatchingDTO;

var SegmentationResultDTO = function SegmentationResultDTO() {
  _classCallCheck(this, SegmentationResultDTO);
};

__decorate([class_validator_1.IsUUID(), __metadata("design:type", String)], SegmentationResultDTO.prototype, "computerVisionFileId", void 0);

exports.SegmentationResultDTO = SegmentationResultDTO;

var SegmentationUpdateDTO =
/*#__PURE__*/
function (_CompVisionRequestUpd6) {
  _inherits(SegmentationUpdateDTO, _CompVisionRequestUpd6);

  function SegmentationUpdateDTO() {
    _classCallCheck(this, SegmentationUpdateDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SegmentationUpdateDTO).apply(this, arguments));
  }

  return SegmentationUpdateDTO;
}(CompVisionRequestUpdateDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return SegmentationResultDTO;
}), __metadata("design:type", SegmentationResultDTO)], SegmentationUpdateDTO.prototype, "processingResult", void 0);

exports.SegmentationUpdateDTO = SegmentationUpdateDTO;

var SegmentationDTO =
/*#__PURE__*/
function (_ComputerVisionDTO6) {
  _inherits(SegmentationDTO, _ComputerVisionDTO6);

  function SegmentationDTO() {
    _classCallCheck(this, SegmentationDTO);

    return _possibleConstructorReturn(this, _getPrototypeOf(SegmentationDTO).apply(this, arguments));
  }

  return SegmentationDTO;
}(ComputerVisionDTO);

__decorate([class_validator_1.ValidateNested(), class_transformer_1.Type(function () {
  return SegmentationResultDTO;
}), __metadata("design:type", SegmentationResultDTO)], SegmentationDTO.prototype, "processingResult", void 0);

exports.SegmentationDTO = SegmentationDTO;